import { z } from "zod";
export const CautionStatusEnum = {
    PENDING: "pending",
    PAID: "paid",
    RELEASED_FULL: "released",
    RELEASED_PARTIAL: "partial",
    CANCELED: "canceled",
};
export const cautionStatusSchema = z.enum([
    CautionStatusEnum.PENDING,
    CautionStatusEnum.PAID,
    CautionStatusEnum.RELEASED_FULL,
    CautionStatusEnum.RELEASED_PARTIAL,
    CautionStatusEnum.CANCELED,
]);
